export const Experiments: Record<string, number> = {
    DOLPHINS_IDENTIFICATION_BUSINESS: 4782,
};
